import React from 'react';

interface TrocaIconeProps {
  /** Qual dos dois está valendo agora. */
  ativo: boolean;
  quandoAtivo: React.ReactNode;
  quandoInativo: React.ReactNode;
  /** Tamanho da caixa. Os dois ícones ocupam a MESMA — nada de empurrar o texto. */
  className?: string;
}

/**
 * Troca um ícone por outro sem corte seco.
 *
 * O ternário `{x ? <A/> : <B/>}` desmonta um e monta o outro no mesmo frame, e
 * quando os dois têm larguras diferentes ainda empurra o rótulo ao lado. Aqui os
 * dois ficam montados na mesma caixa e trocam por opacidade + escala + desfoque.
 *
 * `aria-hidden` porque quem anuncia o estado é o rótulo ou o `aria-label` do
 * botão em volta — o ícone é decoração do que já está escrito.
 */
export default function TrocaIcone({
  ativo,
  quandoAtivo,
  quandoInativo,
  className = 'w-4 h-4',
}: TrocaIconeProps) {
  return (
    <span className={`relative flex-shrink-0 ${className}`} aria-hidden="true">
      <span
        className={`absolute inset-0 flex items-center justify-center transition-[opacity,transform,filter] duration-150 ${
          ativo ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-90 blur-[2px]'
        }`}
      >
        {quandoAtivo}
      </span>
      <span
        className={`absolute inset-0 flex items-center justify-center transition-[opacity,transform,filter] duration-150 ${
          ativo ? 'opacity-0 scale-90 blur-[2px]' : 'opacity-100 scale-100 blur-0'
        }`}
      >
        {quandoInativo}
      </span>
    </span>
  );
}
